import React from 'react';

interface AutoTagChipsProps {
  tags?: string[];
  /** Store has automatic tags on. When off, the chips show what WOULD be added. */
  active?: boolean;
}

/** Automatic tags this product gets in the merchant's store (W5). */
const AutoTagChips: React.FC<AutoTagChipsProps> = ({ tags, active }) => {
  if (!tags || tags.length === 0) return null;
  return (
    <div
      className={`flex flex-wrap gap-1 ${active ? '' : 'opacity-50'}`}
      title={active
        ? 'Tags FlowStock adds in your store automatically'
        : 'Automatic tags are off for your store (Processor Config → Tags). These would be added.'}
    >
      {tags.map((t) => (
        <span
          key={t}
          className="inline-block px-1.5 py-0.5 rounded text-[10px] font-medium bg-orange-500/10 border border-orange-500/20 text-orange-300 truncate max-w-[10rem]"
        >
          {t}
        </span>
      ))}
    </div>
  );
};

export default AutoTagChips;
